import {
  IParentWidgetScope,
  collectExpressionReferences,
  createEvaluationVariables,
  evaluateExpression,
  getWidgetName,
  mapReferenceToPath,
  setComputedBooleanTransform,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { IModuleTriggerWidget } from './IModuleTriggerWidget';
import { TriggerModuleMetaKey } from './ModuleTriggerWidget.type';

export const ModuleTriggerModuleUniqueCodeMetaKey =
  'ModuleTriggerModuleUniqueCode';

export const ModuleTriggerTitleMetaKey = 'ModuleTriggerTitle';

export interface ITriggeredModuleMeta {
  moduleId: string;
}

export function getModuleTriggerUniqueCodeName(widget: IModuleTriggerWidget) {
  return `${getWidgetName(widget)}@internal_uniqueModuleCode`;
}

export function createModuleTriggerFormSchema(input: {
  widget: IModuleTriggerWidget;
  parentScope: IParentWidgetScope;
}) {
  const { widget, parentScope } = input;

  const name = getWidgetName(widget);

  const meta: ITriggeredModuleMeta = {
    moduleId: widget.moduleId,
  };

  let widgetSchema = setComputedBooleanTransform(
    widget,
    parentScope,
    yup
      .boolean()
      .notRequired()
      .meta({
        [TriggerModuleMetaKey]: meta,
      }),
  );

  if (widget.needUniqueModuleCode && widget.uniqueModuleCode) {
    // Se è indicato un codice univoco modulo, lo risolvo in fase di validazione
    // (il campo è un'expression)
    const codeExpression = widget.uniqueModuleCode;
    const codeReferences = collectExpressionReferences(codeExpression);
    const codePaths = codeReferences.map(r => mapReferenceToPath(r));
    widgetSchema = widgetSchema.parentWhen(
      codePaths,
      (values, schema: yup.AnySchema, context: any) => {
        const variables = createEvaluationVariables(codeReferences, values);
        const result = evaluateExpression(codeExpression, { variables });

        return schema.meta({ [ModuleTriggerModuleUniqueCodeMetaKey]: result });
      },
    );
  }

  if (widget.title) {
    // Risoluzione campo titolo
    const titleExpression = widget.title;
    const titleReferences = collectExpressionReferences(titleExpression);
    const titlePaths = titleReferences.map(r => mapReferenceToPath(r));

    widgetSchema = widgetSchema.parentWhen(titlePaths, (values, schema) => {
      const variables = createEvaluationVariables(titleReferences, values);
      const result = evaluateExpression(titleExpression, { variables });

      return schema.meta({ [ModuleTriggerTitleMetaKey]: result });
    });
  }

  return {
    [name]: widgetSchema,
  };
}
